import type { ReactNode } from 'react';
import { Button } from './Button';
export function EmptyState({ icon, title, body, cta, onCta }: { icon?: ReactNode; title: string; body: string; cta?: string; onCta?: () => void }) {
  return (
    <div className="text-center px-8 py-16">
      {icon ? <div className="mb-5 inline-flex items-center justify-center w-16 h-16 rounded-full bg-paper-rec text-ink-2">{icon}</div> : null}
      <h3 className="t-ed-xl mb-2">{title}</h3>
      <p className="t-ui text-ink-2 max-w-xs mx-auto mb-6">{body}</p>
      {cta && onCta && <Button variant="primary" onClick={onCta}>{cta}</Button>}
    </div>
  );
}
